import { useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Plus } from 'lucide-react'
import { RouteErrorFallback } from '@/components/ErrorBoundary'
import {
  PageContainer, PageCard, PageHeader, PageHeaderContent,
  PageHeaderTitle, PageHeaderHeading, PageHeaderDescription, PageContent
} from '@/components/ui/page'
import { Button } from '@/components/ui/button'
import { TelephonyNumbersTable } from '@/components/admin/telephony/TelephonyNumbersTable'
import { PurchaseNumberDialog } from '@/components/admin/telephony/PurchaseNumberDialog'
import { useAdminTelephonyNumbers } from '@/hooks/admin/useAdminTelephonyNumbers'

export const Route = createFileRoute('/admin/telephony/')({
  component: TelephonyAdmin,
  errorComponent: RouteErrorFallback,
})

function TelephonyAdmin() {
  const [purchaseOpen, setPurchaseOpen] = useState(false)
  const { data: numbers } = useAdminTelephonyNumbers()
  const issueCount = (numbers ?? []).filter((n) => (n.issues ?? []).length > 0).length
  const countSuffix = numbers
    ? ` · ${numbers.length} ${numbers.length === 1 ? 'Nummer' : 'Nummern'}${issueCount > 0 ? `, ${issueCount} mit Problemen` : ''}`
    : ''

  return (
    <>
    <PageContainer>
      <PageCard>
        <PageHeader>
          <PageHeaderContent>
            <PageHeaderTitle>
              <PageHeaderHeading>Telefonie</PageHeaderHeading>
              <PageHeaderDescription>
                Verwaltung aller Twilio-Rufnummern und Trunk-Zuordnungen{countSuffix}
              </PageHeaderDescription>
            </PageHeaderTitle>
            <Button size="sm" onClick={() => setPurchaseOpen(true)}>
              <Plus className="h-4 w-4 mr-1" />
              Nummer kaufen
            </Button>
          </PageHeaderContent>
        </PageHeader>
        <PageContent className="p-4">
          <TelephonyNumbersTable className="flex-1 min-h-0" />
        </PageContent>
      </PageCard>
    </PageContainer>

    <PurchaseNumberDialog open={purchaseOpen} onOpenChange={setPurchaseOpen} />
    </>
  )
}
